import { getOffsetTop } from '../../../../src/js/utils/functions';

class ColoredBorderSection {
	section: HTMLElement;
	colorBorder: HTMLElement | null;
	sectionScrollTop: number;

	constructor(element: HTMLElement) {
		this.section = element;
		this.colorBorder = element.querySelector('.block-section__color-border');
		this.sectionScrollTop = getOffsetTop(element);

		window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
		window.addEventListener('resize', this.handleResize.bind(this), { passive: true });
		window.addEventListener('load', this.handleResize.bind(this), { passive: true });
	}

	handleScroll() {
		const adminBarOffset = document.getElementById('wpadminbar')?.offsetHeight ?? 0;
		const scrollPos = window.scrollY + adminBarOffset;

		if (
			scrollPos > this.sectionScrollTop &&
			scrollPos - this.sectionScrollTop < this.section.offsetHeight - window.innerHeight
		) {
			this.section.classList.add('is-sticking');
		} else {
			this.section.classList.remove('is-sticking');
		}

		if (
			scrollPos - this.sectionScrollTop >= this.section.offsetHeight - window.innerHeight &&
			this.colorBorder &&
			this.section.offsetHeight - window.innerHeight - adminBarOffset > 0
		) {
			this.colorBorder.style.top = `${this.section.offsetHeight - window.innerHeight - adminBarOffset}px`;
			this.section.classList.add('round-borders');
		} else if (this.colorBorder) {
			this.section.classList.remove('round-borders');
			this.colorBorder.style.top = `${adminBarOffset}px`;
		}
	}

	handleResize() {
		this.sectionScrollTop = getOffsetTop(this.section);
	}
}

class ParallaxBackgroundSection {
	section: HTMLElement;
	sectionScrollTop: number;

	constructor(element: HTMLElement) {
		this.section = element;
		this.sectionScrollTop = getOffsetTop(element);

		this.setSectionBeforeClass();
		window.addEventListener('scroll', this.checkScrollPosition.bind(this), { passive: true });
		window.addEventListener('resize', this.handleResize.bind(this), { passive: true });
	}

	handleResize() {
		this.sectionScrollTop = getOffsetTop(this.section);
		this.checkScrollPosition();
	}

	checkScrollPosition() {
		const adminBarOffset = document.getElementById('wpadminbar')?.offsetHeight ?? 0;
		const scrollPos = window.scrollY + adminBarOffset;

		if (
			scrollPos + window.innerHeight + 200 > this.sectionScrollTop &&
			scrollPos - 200 < this.sectionScrollTop + this.section.offsetHeight
		) {
			this.section.classList.add('in-view');
		} else {
			this.section.classList.remove('in-view');
		}
	}

	setSectionBeforeClass() {
		if (this.section.previousElementSibling?.classList.contains('block-section')) {
			this.section.previousElementSibling.classList.add('round-bottom-borders');
		}
	}
}

const whiteColorBorder = document.querySelectorAll<HTMLElement>('.bg-white-color-border');

whiteColorBorder.forEach((section) => {
	new ColoredBorderSection(section);
});

const parallaxBackground = document.querySelectorAll<HTMLElement>('.bg-parallax');

parallaxBackground.forEach((section) => {
	new ParallaxBackgroundSection(section);
});
